import { Card, CardBody, Chip } from '@nextui-org/react';
import { useMemo } from 'react';

export interface ChatViewProps {
  chatId?: string;
  chatBox?: JSX.Element;
  chatType?: string;
}

export default function ChatView({ chatId, chatBox, chatType }: ChatViewProps) {
  const wrappedChatBox = useMemo(
    () =>
      chatId &&
      chatBox && (
        <CardBody key="chat-box" className="p-0 flex-1 min-h-0">
          {chatBox}
        </CardBody>
      ),
    [chatId, chatBox]
  );

  return (
    <Card
      key={chatId || 'no-chat'}
      className={`relative flex flex-col w-full h-full min-h-0 ${chatType ? (chatType === 'assistant' ? 'assistant-chat-view' : 'client-chat-view') : ''}`}
    >
      {!chatId && (
        <Chip variant="flat" className="m-auto">
          Select a chat
        </Chip>
      )}
      {wrappedChatBox}
    </Card>
  );
}
